import { useParams, Link } from 'react-router-dom';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import Origin from './components/Origin';
import Story from './components/Story';
import Profile from './components/Profile';
import Gallery from './components/Gallery';
import ComingSoon from './components/ComingSoon';
import { nomoCharacters } from '@/mocks/characters';
import { characterDetails } from '@/mocks/characterDetail';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CharacterPage() {
  const { id } = useParams<{ id: string }>();
  useScrollReveal();

  const character = nomoCharacters.find((item) => item.id === id);
  const detail = characterDetails.find((item) => item.id === id);

  if (!character) {
    return (
      <div className="min-h-screen w-full bg-background-50">
        <SiteNavbar />
        <main className="flex min-h-[60vh] items-center justify-center px-4">
          <div className="text-center">
            <p className="font-heading text-2xl text-foreground-950">这个 NOMO 灵还没登场</p>
            <p className="mt-3 text-sm text-foreground-600">它还在某个地方的风土里，慢慢成形。</p>
            <Link
              to="/"
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors duration-300 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              返回首页
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </main>
        <SiteFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNavbar />
      <main>
        <Hero character={character} detail={detail} />
        {!character.debut && <ComingSoon character={character} />}
        <Origin detail={detail} />
        <Story detail={detail} />
        <Profile detail={detail} />
        <Gallery detail={detail} character={character} />
      </main>
      <SiteFooter />
    </div>
  );
}